export default __webpack_public_path__ + "static/media/GreenTick.3952cefe.svg";